import "reveal.js/dist/reveal.css";
import "suneditor/dist/css/suneditor.min.css";
import "nouislider/dist/nouislider.css";
import "../styles/globals.css";
import "../styles/reveal-overrides.css";
import "../styles/print-mode.css";
// The following import prevents a Font Awesome icon server-side rendering bug,
// where the icons flash from a very large icon down to a properly sized one:
import "@fortawesome/fontawesome-svg-core/styles.css";
import "resize-observer-polyfill";

// Prevent fontawesome from adding its CSS since we did it manually above:
import { config } from "@fortawesome/fontawesome-svg-core";
import { DefaultSeo } from "next-seo";
import { AppProps } from "next/app";
import Head from "next/head";
import { Provider } from "react-redux";

import favicon from "../public/favicon.ico";
import { stubTouchEvent } from "../src/lib/TouchEvent.stub";
import { makeWrapper } from "../src/store";
import { AppVariablesProvider } from "@/lib/app-variables/provider";

config.autoAddCss = false; /* eslint-disable import/first */

// Need to make sure window.TouchEvent exists because @svg-drawing library uses it
stubTouchEvent();

export default function App({ Component, ...rest }: AppProps & { err?: Error }) {
  const { appVariables } = rest.pageProps;
  const { store, props } = makeWrapper(appVariables?.APP_ENV === "development").useWrappedStore(rest);

  return (
    <>
      <DefaultSeo
        titleTemplate="Solar Proposal for %s"
        defaultTitle="Solar Energy Project"
        description="Your solar proposal created by Enerflo"
      />
      <Head>
        <link rel="icon" href={favicon.src} />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="theme-color" content="#000000" />
        <GoogleAnalytics token={appVariables?.GOOGLE_ANALYTICS} />
      </Head>
      <AppVariablesProvider variables={appVariables}>
        <Provider store={store}>
          <Component {...props.pageProps} err={props.err} />
        </Provider>
      </AppVariablesProvider>
    </>
  );
}

function GoogleAnalytics({ token }: { token: string | undefined }): JSX.Element {
  if (token) {
    return (
      <>
        <script async src={`https://www.googletagmanager.com/gtag/js?id=${token}`} />{" "}
        <script
          dangerouslySetInnerHTML={{
            __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${token}', {
              page_path: window.location.pathname,
            });
          `,
          }}
        />
      </>
    );
  }
  // For some reason NextJs doesn't handle null, or empty fragments in the <Head>
  return <meta></meta>;
}
